import * as Constants from '../constants';
import * as WelcomeMat from '../data/WelcomeMat';
import * as FtuxWalkthrough from '../data/FtuxWalkthrough';

export function openModal(modal, data) {
  return dispatch =>
    dispatch({
      type: Constants.OPEN_MODAL,
      modal,
      data
    });
}

export function closeModal(modal) {
  return dispatch =>
    dispatch({
      type: Constants.CLOSE_MODAL,
      modal
    });
}

export function updateModal(modal, data) {
  return dispatch =>
    dispatch({
      type: Constants.UPDATE_MODAL,
      modal,
      data
    });
}

export function initWelcomeMatStatus(name) {
  return dispatch =>
    dispatch({
      type: Constants.UPDATE_WELCOME_MAT,
      name,
      shouldOpen: WelcomeMat.shouldShowWelcomeMat(name)
    });
}

export function closeWelcomeMat(name) {
  return dispatch =>
    WelcomeMat.close(name)
      .then(
        dispatch({
          type: Constants.UPDATE_WELCOME_MAT,
          name,
          shouldOpen: false
        })
      )
      .then(closeModal(name)(dispatch));
}

export function updateWelcomeMat(shouldOpen, name) {
  return dispatch =>
    WelcomeMat.update(shouldOpen, name).then(
      dispatch({
        type: Constants.UPDATE_WELCOME_MAT,
        name,
        shouldOpen
      })
    );
}

export function startWalkthrough() {
  return {
    type: Constants.START_WALKTHROUGH
  };
}

export function nextWalkthroughStep() {
  return {
    type: Constants.INCREMENT_WALKTHROUGH_STEP
  };
}

export function closeWalkthrough() {
  return dispatch =>
    FtuxWalkthrough.dismiss().then(
      dispatch({
        type: Constants.CLOSE_WALKTHROUGH
      })
    );
}
